module.exports = __webpack_public_path__ + "img/8_29.7c17005a.png";